export const css = {
    underlayVisible: 'kNJyoq-G',
    ' _key': 'afcpe-theme/dojo/popup'
};
export default css;
